// ABOUTME: PRO upsell shown where a translation exists but the plan doesn't cover it.
// ABOUTME: Split out so the router hook only runs when a lock is actually rendered.

import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import { LockIcon, TranslateIcon } from "@shared/icons"
import { SUBSCRIPTION_PATH } from "@shared/constants/navigation"

interface IProps {
  className?: string
}

export const L10nLockedHint = ({ className = "" }: IProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <button
      type="button"
      onClick={() => navigate(SUBSCRIPTION_PATH)}
      className={`mt-1 inline-flex items-center gap-1 text-xs text-[#7C3AED] hover:underline ${className}`}
    >
      <TranslateIcon
        size={12}
        color="#C4B5FD"
      />
      <LockIcon
        size={10}
        color="#7C3AED"
      />
      <span>{t("l10n.lockedHint")}</span>
    </button>
  )
}

export default L10nLockedHint
